<nz-modal
  *ngIf='isShowBarcodeChargeModal'
  [(nzVisible)]="isShowBarcodeChargeModal"
  [nzMaskClosable]="false"
  (nzOnCancel)="closeBarcodeModal($event)"
  (nzAfterOpen)='onFocusBarcodeInput()'
  [nzFooter]='null'
  nzTitle="扫码支付"
  nzWidth="820">
  <nz-spin [nzSpinning]='barcodeChargeSpinning'>
    请等待用户扫码
    <input style='margin-bottom: 20px' #custBarcodeInput nz-input type='text' [(ngModel)]='custBarcode' (keydown)='handleBarcodeCharge($event);$event.stopPropagation()'>
  </nz-spin>
</nz-modal>
